import { render, staticRenderFns } from "./SuiteMembers.vue?vue&type=template&id=78fd082a&"
import script from "./SuiteMembers.vue?vue&type=script&lang=js&"
export * from "./SuiteMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports